import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, Output, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { DynamicContentService } from '@services/dynamic-content/dynamic-content.service';
import { DynamicContentEntranceService } from '@services/dynamic-content/dynamic-content-entrance.service';
import { DynamicContentTableRowComponent } from './dynamic-content-table-row/dynamic-content-table-row.component';
import * as _ from 'lodash';
import { PipeImportService } from '@services/pipe-imports/pipe-import.service';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '@services/environment/environment.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@services/translate/translate.service';
import { DialogService } from '@services/dialog/dialog.service';
import { ProductService } from '@services/products/product.service';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { MatSelect } from '@angular/material/select';
import { PreviewComponent } from '../preview/preview.component';
import { ContentPipeService } from '@services/content-pipe/content-pipe.service';
import { MatDialog } from '@angular/material/dialog';
import { PackageInstalledWidgetsService } from '@services/packages/package-installed-widgets.service';
import { AddItemsFromList } from '../../pages/user-admin/user-admin-edit/dialogs/add-items-from-list/add-items-from-list.component';

@Component({
  selector: 'dynamic-content-table',
  templateUrl: './dynamic-content-table.component.html',
  styleUrls: ['./dynamic-content-table.component.scss'],
  providers: [DynamicContentService, DynamicContentEntranceService, ProductService, PackageInstalledWidgetsService],
  standalone: false
})
export class DynamicContentTableComponent implements OnChanges, AfterViewInit, OnDestroy {
  @Input() data: any;
  @Input() archiveData: any;
  @Input() liveData: any;
  @Input() categories: any;
  @Input() loading: boolean;
  @Input() entrance: Models.DynamicContentEntrance;
  @Input() packageId: string;
  @Input() archive = false;
  @Input() showOrder = false;
  @Input() type = '';
  @Input() app: Models.PackageInstalledApp;
  @Input() globalEntries: any[];
  widget: Models.PackageInstalledWidget;
  @Output() content: EventEmitter<any> = new EventEmitter();
  @ViewChild('actionHeaderSelect') actionHeaderSelect!: MatSelect;
  @ViewChildren(DynamicContentTableRowComponent) rows!: QueryList<DynamicContentTableRowComponent>;

  resizeObserver!: ResizeObserver;

  noDragAndDropItems = ['activity', 'alphabet', 'event', 'gastronomy', 'person', 'restaurant'];
  showSubs = [];
  items: any[] = [];
  selectedItems = [];
  checkBoxActions: any[] = [];
  searchValue: string;
  systemMessages: any;
  public pipes: Models.PipeImport[];
  private currentPipe;
  public showReloadPipeData = false;
  public showInitPipeData = false;
  public showPreview = false;
  public showLoader = false;
  private parentIds;
  private itemId;
  private translationsById: any = {};

  translations;
  medium = false;
  short = false;

  constructor(
    private entryService: DynamicContentService, private entranceService: DynamicContentEntranceService, private pipeService: PipeImportService, private http: HttpClient,
    private environmentService: EnvironmentService, private router: Router, private ts: TranslateService, private dialogService: DialogService, private widgetService: PackageInstalledWidgetsService,
    private snackbar: SnackbarService, private contentPipeService: ContentPipeService, private dialog: MatDialog, private el: ElementRef, private activatedRoute: ActivatedRoute
  ) {
    this.init();
    this.parentIds = this.activatedRoute.snapshot.queryParams['parentIds'];
    this.itemId = this.activatedRoute.snapshot.queryParams['item'];
  }

  search() {
    for (const element of this.items) {
      element.hidden = !!this.searchValue.length ? !element.data.title.toLowerCase().includes(this.searchValue.toLowerCase()) : false;
      for (const child of element.children || []) {
        if (!!child.data.title.toLowerCase().includes(this.searchValue.toLowerCase())) {
          element.hidden = false;
          element.showSub = true;
          this.rows.forEach(el => {
            if (element === el.item) {
              el.expand(true);
            }
          });
        }
        for (const subChild of child.children || []) {
          if (!!subChild.data.title.toLowerCase().includes(this.searchValue.toLowerCase())) {
            element.hidden = false;
            element.showSub = true;
          }
        }
      }
    }
  }

  initCheckboxActions() {
    this.checkBoxActions = [];
    this.checkBoxActions.push({
      translation: 'dynamicContent.deleteMultipleItems', icon: 'delete', action: () => {
        this.deleteSelectedItems()
      }
    });
    this.checkBoxActions.push({
      translation: 'dynamicContent.publishMultipleItems', icon: 'visibility', action: () => {
        this.setPublished(true)
      }
    });
    this.checkBoxActions.push({
      translation: 'dynamicContent.unpublishMultipleItems', icon: 'visibility_off', action: () => {
        this.setPublished(false)
      }
    });
    if (this.entrance?.type === 'alphabet') {
      this.checkBoxActions.push({
        translation: 'dynamicContent.setGoodToKnow', icon: 'check_box', action: () => {
          this.setGoodToKnowSelectedItems(true)
        }
      });
      this.checkBoxActions.push({
        translation: 'dynamicContent.unsetGoodToKnow', icon: 'check_box_outline_blank', action: () => {
          this.setGoodToKnowSelectedItems(false)
        }
      });
    }
  }

  private async deleteSelectedItems() {
    const childIds = [];
    let ids = JSON.parse(JSON.stringify(this.selectedItems));
    for (const id of ids) {
      const item = this.items.find(el => el.data._id === id);
      for (const child of item.children || []) {
        childIds.push(child.data._id);
        for (const subChild of child.children || []) {
          childIds.push(subChild.data._id);
        }
      }
    }
    let confirmMessage = this.systemMessages.dynamicContent.confirm_delete_multiple_first + ids.length + this.systemMessages.dynamicContent.confirm_delete_multiple_second;
    if (ids.length === 1) {
      confirmMessage = this.systemMessages.dynamicContent.confirm_delete;
    }
    let title: string;
    if (childIds.length) {
      title = confirmMessage;
      confirmMessage = '<b>' + this.systemMessages.dynamicContent.children_amount_first + childIds.length + this.systemMessages.dynamicContent.children_amount_second + '</b>';
    }
    const dialogRes = await this.dialogService.confirm(confirmMessage, title);
    if (!dialogRes) {
      return;
    }
    ids = ids.filter(el => !childIds.includes(el));
    const promises = [];
    for (const id of ids) {
      const finalChildIds = [];
      const item = this.items.find(el => el.data._id === id);
      for (const child of item.children || []) {
        finalChildIds.push(child.data._id);
        for (const subChild of child.children || []) {
          finalChildIds.push(subChild.data._id);
        }
      }
      promises.push(this.executeDelete(item, finalChildIds));
    }
    await Promise.all(promises);
    childIds.concat(ids);
    this.items = this.items.filter(el => !childIds.includes(el.data._id));
    this.data = this.revertItemsToData(JSON.parse(JSON.stringify(this.items)));
    this.selectedItems = [];
  }

  private async setPublished(value) {
    const promises = [];
    for (const id of this.selectedItems) {
      promises.push(this.entryService.patch(id, { published: value }));
      this.items[this.items.findIndex(el => el.data._id === id)].data.published = value;
    }
    await Promise.all(promises);
  }

  private async setGoodToKnowSelectedItems(value: boolean) {
    const promises = [];
    for (const id of this.selectedItems) {
      promises.push(this.entryService.patch(id, { 'content.goodToKnow': value }));
      this.items[this.items.findIndex(el => el.data._id === id)].data.content.goodToKnow = value;
    }
    await Promise.all(promises);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.data?.live) {
      this.data = this.data.live
    }
    this.selectedItems = [];
    this.init();
    this.checkCurrentPipe(this.entrance?._id);
  }

  async init() {
    if ((this.data || []).find(e => !!e?.translation || !!e?.data?.translation || !!e?.data?.data?.translation)) {
      this.setTranslationsById(this.data);
    }
    try {
      this.widget = !!this.app?.packageInstalledWidgetId ? await this.widgetService.get(this.app?.packageInstalledWidgetId) : this.widget;
    } catch (err) {
      console.warn(err);
    }
    if (!this.translations) {
      this.translations = this.ts.get('');
    }
    this.initCheckboxActions();
    this.systemMessages = this.ts.get('system');
    this.showSubs = [];
    if (!this.data) {
      return;
    }
    const items = [];
    for (const element of this.data?.live || this.data) {
      element['parent'] = 'root';
      element['level'] = 0;
      element['showSub'] = this.showSubs.includes(element.data._id);
      items.push(element);
      for (const child of element.children || []) {
        if (!child.data) {
          child.data = child;
        }
        child['parent'] = element.data._id;
        child['level'] = 1;
        child['showSub'] = this.showSubs.includes(child.data?._id);
        items.push(child);
        for (const subChild of child.children || []) {
          if (!subChild.data) {
            subChild.data = child;
          }
          subChild['parent'] = child.data._id;
          subChild['level'] = 2;
          items.push(subChild);
        }
      }
    }
    this.items = items;
    const previewTypes = ['information', 'news', 'restaurant', 'opening-hours', 'event', 'gallery', 'social-media', 'ticker'];
    this.showPreview = previewTypes.includes(this.entrance?.config?.overwriteContentType || this.entrance?.type);
    if (this.parentIds) {
      const parentIdsArr = this.parentIds.split(',');
      for (const id of parentIdsArr) {
        const item = this.items.find(el => el.data._id === id);
        if (item) {
          this.toggleSub(item);
        }
      }
      const previousItem = document.getElementById(this.itemId);
      if (previousItem) {
        previousItem.scrollIntoView({ behavior: 'smooth'});
      }
    }
  }

  ngAfterViewInit() {
    this.resizeObserver = new ResizeObserver(entries => {
      this.medium = !!entries.find(entry => { return entry?.contentRect?.width < 770 } );
      this.short = !!entries.find(entry => { return entry?.contentRect?.width < 500 } );
    });
    if (this.el?.nativeElement?.parentElement) {
      this.resizeObserver.observe(this.el.nativeElement.parentElement);
    }
  }

  ngOnDestroy() {
    this.resizeObserver?.disconnect();
  }

  revertItemsToData(items) {
    const data = [];
    const itemMap = new Map();
    for (const item of items) {
      item.children = [];
      itemMap.set(item.data._id, item);
    }
    for (const item of items) {
      if (item.parent === 'root') {
        data.push(item);
      } else {
        const parentItem = itemMap.get(item.parent);
        parentItem.children.push(item);
      }
    }
    data.forEach(el => {
      this.cleanUpProperties(el)
    });
    return data;
  }

  cleanUpProperties(item) {
    delete item.parent;
    delete item.level;
    delete item.showSub;
    if (item.children.length > 0) {
      item.children.forEach(el => {
        this.cleanUpProperties(el);
      });
    } else {
      delete item.children;
    }
  }

  isItemHidden(item) {
    if (item.parent === 'root') {
      return false;
    } else {
      return !this.items.find(el => el.data._id === item.parent).showSub;
    }
  }

  async drop(event: CdkDragDrop<string[]>) {
    const previousContainer = this.items[event.previousIndex].parent;
    const currentContainer = this.items[event.currentIndex].parent;
    moveItemInArray(this.items, event.previousIndex, event.currentIndex);
    this.items[event.currentIndex].parent = currentContainer;
    this.items[event.currentIndex].level = currentContainer === 'root' ? 0 : this.items.find(el => el.data._id === currentContainer).level + 1;
    this.data = this.revertItemsToData(JSON.parse(JSON.stringify(this.items)));
    const promises = [this.saveNewOrder(currentContainer)];
    if (currentContainer !== previousContainer) {
      promises.push(this.saveNewOrder(previousContainer));
    }
    await Promise.all(promises);
    this.fixTranslations(this.items);
    this.fixTranslations(this.data);
  }

  fixTranslations(elements) {
    for (let element of elements) {
      if (element.children) {
        this.fixTranslations(element.children);
      }
      if (element._id) {
        element.translation = this.translationsById[element._id];
      } else if (element?.data?._id) {
        element.data.translation = this.translationsById[element.data._id];
      } else if (element?.data?.data?._id) {
        element.data.data.translation = this.translationsById[element.data.data._id];
      }
    }
  }

  setTranslationsById(elements: any[]) {
    for (let element of elements) {
      if (element.children) {
        this.setTranslationsById(element.children);
      }
      this.translationsById[element?._id || element?.data?._id || element?.data?.data?._id] = element?.translation || element?.data?.translation || element?.data?.data?.translation;
    }
  }

  async saveNewOrder(container) {
    const content = JSON.parse(JSON.stringify(this.data));
    const item = JSON.parse(JSON.stringify(container === 'root' ? this.entrance : this.findById(content, container)));
    const promises = [];
    if (container === 'root') {
      if (this.type === 'category') {
        item.categories = content.map(el => el.data._id);
        promises.push(this.entranceService.patch(this.entrance._id, {categories: item.categories}));
        for (let i = 0; i < item.categories.length; i++) {
          promises.push(this.entryService.patch(item.categories[i], { order: i }));
        }
        await Promise.all(promises);
        return this.init();
      } else {
        item.children = content.map(el => el.data._id);
        promises.push(this.entranceService.patch(this.entrance._id, { children: (this.liveData?.map(el => el.data._id) || []).concat(content.map(el => el.data._id)).concat(this.archiveData?.map(el => el.data._id) || []) }));
      }
    } else {
      item.data.children = item.children.map(el => el.data._id);
      promises.push(this.entryService.patch(container, { children: item.children.map(el => el.data._id) }));
    }
    for (let i = 0; i < item.children.length; i++) {
      const subItem = JSON.parse(JSON.stringify(this.findById(content, item.children[i].data?._id || item.children[i])));
      const data = subItem.data;
      if (data.global) {
        data.orderByPackage = data.orderByPackage || {};
        data.orderByPackage[this.packageId] = i;
        promises.push(this.entryService.patch(data._id, { children: subItem.children ? subItem.children.map(el => el.data._id) : [], orderByPackage: data.orderByPackage }));
      } else {
        promises.push(this.entryService.patch(data._id, { children: subItem.children ? subItem.children.map(el => el.data._id) : [], order: i }));
      }
    }
    await Promise.all(promises);
    this.init();
  }

  findById(data, id) {
    for (const element of data) {
      if (element.data._id === id) {
        return element;
      } else if (element.children && this.findById(element.children, id)) {
        return this.findById(element.children, id);
      }
    }
    return null;
  }

  toggleSub(item) {
    if (!this.showSubs.includes(item.data._id)) {
      this.showSubs.push(item.data._id);
    } else {
      this.showSubs.splice(this.showSubs.indexOf(item.data._id), 1);
    }
    if (!!item['showSub'] && item.children) {
      for (const child of item.children) {
        this.rows.forEach(row => {
          if (row.item.data._id === child.data._id) {
            row.collapse(true);
          }
        });
        child['showSub'] = false;
      }
    }
    item['showSub'] = !item['showSub'];
  }

  select(item) {
    if (this.selectedItems.includes(item.data._id)) {
      this.selectedItems.splice(this.selectedItems.indexOf(item.data._id), 1);
    } else {
      this.selectedItems.push(item.data._id);
    }
  }

  async preview(item) {
    if (this.packageId) {
      window['forcePackage'] = this.packageId;
    }
    const content = JSON.parse(JSON.stringify(item.data));
    content['app'] = this.app;
    content['widget'] = this.widget;
    const data = this.contentPipeService.getTransformedEntry(content, this.entrance);
    this.dialog.open(PreviewComponent, <any>{ width: '95vw', height: '95vh', panelClass: 'preview-modal', data: data });
  }

  selectAll(force?: string) {
    if (this.selectedItems.length === this.items.length || force === 'unselect') {
      this.rows.forEach(row => {
        row.unselect(true);
      });
      this.selectedItems = [];
    } else {
      this.rows.forEach(row => {
        row.expand(true);
        row.select(true);
      });
      this.items.forEach(el => {
        el.showSub = true
      });
      this.selectedItems = this.items.map(el => el.data._id);
    }
  }

  detail(item: any) {
    this.router.navigate(['dynamic-content', item.data.type, item.data._id], {
      queryParams: { parentId: item.parent === 'root' ? this.entrance._id : item.parent, packageId: this.packageId, entranceId: this.entrance._id }
    });
  }

  edit(item: any) {
    if (!!this.entrance?.readonly || item?.global || item?.data?.global) {
      return;
    }
    this.router.navigate(['dynamic-content', item.data.type, item.data._id, 'edit'], {
      queryParams: { parentId: item.parent === 'root' ? this.entrance._id : item.parent, packageId: this.packageId, entranceId: this.entrance._id }
    });
  }

  addChild(item: any) {
    this.router.navigate(['dynamic-content', item.data.type, 'create'], { queryParams: { parentId: item.data._id, entranceId: this.entrance._id, packageId: this.packageId } });
  }

  async executeDelete(item: any, childIds: string[]) {
    try {
      if (!item?.global && !item?.data?.global) {
        for (const id of childIds) {
          await this.entryService.remove(id);
        }
        await this.entryService.remove(item.data._id);
      }
      if (item.parent === 'root') {
        this.entrance.children.splice(this.entrance.children.findIndex(el => el === item.data._id), 1);
        await this.entranceService.update(this.entrance._id, this.entrance);
      } else {
        const entry = await this.entryService.get(item.parent);
        const realItem = this.findById(this.items, item.parent);
        realItem.children = realItem.children.filter(el => el.data._id !== item.data._id);
        entry.children.splice(entry.children.findIndex(el => el === item.data._id), 1);
        await this.entranceService.update(this.entrance._id, this.entrance);
      }
      childIds.push(item.data._id);
      this.items = this.items.filter(el => !childIds.includes(el.data._id));
      this.data = this.revertItemsToData(JSON.parse(JSON.stringify(this.items)));
    } catch (err) {
      this.snackbar.error(this.systemMessages.dynamicContent.delete_failed + ' ' + err);
    }
  }

  async delete(item: any) {
    let title = null;
    let confirmMessage = this.systemMessages.dynamicContent.confirm_delete;
    if (item.data.translationEntries && item.data.translationEntries.length > 0) { // entrance has translations, translations will be removed automatically
      confirmMessage = this.systemMessages.dynamicContent.confirm_delete_translations;
    }
    const childIds = [];
    if (item.data.children && item.data.children.length > 0) {
      title = confirmMessage;
      for (const child of item.children || []) {
        childIds.push(child.data._id);
        for (const subChild of child.children || []) {
          childIds.push(subChild.data._id);
        }
      }
      confirmMessage = '<b>' + this.systemMessages.dynamicContent.children_amount_first + childIds.length +
        this.systemMessages.dynamicContent.children_amount_second + '</b>';
    }
    const dialogRes = await this.dialogService.confirm(confirmMessage, title);
    if (!dialogRes) {
      return;
    }
    await this.executeDelete(item, childIds);
    if (this.selectedItems.includes(item.data._id)) {
      this.selectedItems.splice(this.selectedItems.indexOf(item.data._id), 1);
    }
  }

  allSelected() {
    return !!this.items.length && this.items.length === this.selectedItems.length;
  }

  add() {
    this.router.navigate(['dynamic-content', this.type ? this.type : this.entrance.type, 'create'], { queryParams: { parentId: this.entrance._id,
        entranceId: this.entrance._id, packageId: this.packageId, type: this.type } });
  }

  private async checkCurrentPipe(entranceId: string) {
    if (this.entrance?.OwnerOrganisationID && !this.pipes) {
      await this.initPipeImports(this.entrance.OwnerOrganisationID);
      return this.checkCurrentPipe(entranceId);
    }
    this.showInitPipeData = false;
    this.showReloadPipeData = false;
    this.currentPipe = _.filter(this.pipes, pipe => {
      for (const module of pipe.modules) {
        if (module && module.data && module.data.entranceId === entranceId) {
          return true;
        }
      }
      return false;
    })[0];
    this.showReloadPipeData = this.currentPipe;
    if (this.currentPipe && this.currentPipe.modules && this.currentPipe.modules.length) {
      for (const module of this.currentPipe.modules) {
        if (module.group === 'Request' && module.module === 'Upload') {
          this.showInitPipeData = true;
        }
      }
    }
  }

  private async initPipeImports(OwnerOrganisationID) {
    const pipeResult = await this.pipeService.find(0, 100, {
      OwnerOrganisationID: OwnerOrganisationID, executableByUser: true, toDelete: false,
      'modules.group': 'Target', 'modules.module': 'DynamicContent'
    });
    this.pipes = pipeResult.data;
  }

  async addFromGlobal() {
    const dialogRef = this.dialog.open(AddItemsFromList, {
      width: '1200px', maxHeight: '90%', panelClass: 'select-dialog', data: { availableItems: this.globalEntries, columns: [{ prop: 'title', name: 'Titel' }], idField: '_id' }
    });
    const result = await dialogRef.afterClosed().toPromise();
    if (!result) {
      return;
    }
    this.entrance.children = this.entrance.children.concat(result?.additionalItems || []);
    await this.entranceService.patch(this.entrance._id, { children: this.entrance.children });
    this.content.emit();
  }

  reloadPipeData() {
    this.pipeService.patch(this.currentPipe._id, { forcedExecution: true });
  }

  initPipeData() {
    const source = this.currentPipe?.modules?.find(m => m.group === 'Source')?.module;
    const timestamp = new Date().getTime();
    let input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('id', 'importFileUpload_' + timestamp);
    const acceptedBySource = {
      'CSV': '.csv', 'Excel':  '.xls,.xlsx,.xlsm,.xlsb,.xltx,.xltm,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'json': '.json', 'ics': '.ics', 'xml': '.xml'
    }
    if (source) {
      input.setAttribute('accept', acceptedBySource[source]);
    }
    input.onchange = ((event) => {
      this.loading = true;
      const src: any = event.target;
      if (!src.files[0]) {
        return;
      }

      const file = src.files[0];
      const fileName = file.name.toLowerCase();
      const isValidExt = acceptedBySource[source].split(',').filter(t => t.startsWith('.')).map(t => t.trim()).some(ext => fileName.endsWith(ext));
      const isValidMime = acceptedBySource[source].split(',').filter(t => !t.startsWith('.')).map(t => t.trim()).includes(file.type);

      if (!isValidExt && !isValidMime) {
        this.loading = false;
        this.snackbar.error(this.translations.dynamicContent.wrongFileFormat + '<br>Dateiformat: ' + source);
        src.value = '';
        return;
      }

      const reader = new FileReader();
      reader.addEventListener('load', () => {
        const asset = <any>{};
        asset.data = reader.result === 'string' ? reader.result : reader.result.toString()
        asset.originalFileName = src.files[0].name;
        asset.pipeId = this.currentPipe._id;
        return this.http.post(this.environmentService.getPipeBackendUrl() + 'uploadSourceFile/', asset).subscribe(() => {
          return this.pipeService.patch(this.currentPipe._id, { forcedExecution: true }).then(() => {
            document.getElementsByTagName('body')[0].removeChild(input);
            input = null;
            this.showLoader = true;
            setTimeout(() => {
              this.content.emit();
              setTimeout(() => {
                this.showLoader = false;
              }, 2000);
            }, 10000);
          });
        });
      });
      reader.readAsDataURL(src.files[0]);
    });
    document.getElementsByTagName('body')[0].appendChild(input);
    document.getElementById('importFileUpload_' + timestamp).click();
  }
}
